export default __webpack_public_path__ + "locales/lo-LA/SharingPanel.json?hash=ced057bd456be192dadaa6cbca45f3c2";